import React from 'react';

const TreeViewItemPlaceholder = () => <div className="ws-ui-tree-view-item-placeholder__line" />;

export default TreeViewItemPlaceholder;
